import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useBranding } from "../context/BrandingContext";
import { useContentValue } from "../context/ContentContext";
import LanguageSwitcher from "./LanguageSwitcher";
import BrandLogo from "./BrandLogo";

export default function Footer() {
  const { t } = useTranslation();
  const branding = useBranding();
  const tagline = useContentValue("footer.tagline", branding.tagline);
  const year = new Date().getFullYear();
  const org = branding.organization_name || "Holistor";

  return (
    <footer className="border-t border-border bg-card" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <Link to="/" data-testid="footer-logo"><BrandLogo size="md" /></Link>
          <p className="mt-3 text-sm text-muted-foreground max-w-sm">{tagline}</p>
          <p className="mt-4 text-xs font-mono text-muted-foreground" data-testid="footer-made-by">
            {t("footer.made_by", { org })}
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-wider font-mono font-bold text-muted-foreground">{t("footer.product")}</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/features" className="text-foreground hover:text-primary">{t("nav.features")}</Link></li>
            <li><Link to="/pricing" className="text-foreground hover:text-primary">{t("nav.pricing")}</Link></li>
            <li><Link to="/login" className="text-foreground hover:text-primary">{t("cta.sign_in")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-wider font-mono font-bold text-muted-foreground">{t("footer.resources")}</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/signup" className="text-foreground hover:text-primary">{t("cta.get_started")}</Link></li>
          </ul>
          <div className="mt-6"><LanguageSwitcher /></div>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 text-xs font-mono text-muted-foreground flex flex-wrap items-center justify-between gap-2" data-testid="footer-copyright">
          <span>{t("footer.copyright", { year, org })}</span>
          <span>{branding.app_name} · v1</span>
        </div>
      </div>
    </footer>
  );
}
